import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=5c1f9af8&scoped=true"
import script from "./Buy.vue?vue&type=script&lang=js"
export * from "./Buy.vue?vue&type=script&lang=js"
import style0 from "./Buy.vue?vue&type=style&index=0&id=5c1f9af8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f9af8",
  null
  
)

export default component.exports